import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  GridRowModes,
  DataGridPro,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
  koKR,
  GridCellModes,
} from '@mui/x-data-grid-pro';
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  LinearProgress,
  Link,
  Tooltip,
  Typography,
} from '@mui/material';
import  {
  Add,
  Autorenew,
  CommentBank,
  Delete,
  Info,
  InsertDriveFile,
  ManageSearch,
  Refresh,
  Remove,
  Save,
  Undo,
  MenuBook,
  FindInPage,
  DocumentScanner,
} from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from 'react-resizable-panels';
import { v4 as uuidv4 } from 'uuid';
import { FilePond } from 'react-filepond';
import { gcoreServerUrl, toFileServerUrl, mode } from '../../config';
import uploadLabels from '../../FildPondLabel';
import { FormInputDate, FormInputText } from "../form";
import {
  AlertDialog,
  ConfirmDialog,
  DialogTitleClose,
  PaperComponent,
} from "../dialog";
import {
  CustomNoRowsOverlay,
  // CustomLoadingOverlay,
} from "../datagrid";
import { GlassUtils, dateFormat } from "../../utils";

import * as gclientG04docuGCertificationMapActions from "../../store/gclientG04docuGCertificationMap";
import * as gclientG04docuGTestMapActions from "../../store/gclientG04docuGTestMap";
import * as g04docuFileActions from "../../store/g04docuFile";
import * as gtestComparisonActions from "../../store/gtestComparison";
import * as g04docuGTestComparisonActions from "../../store/g04docuGTestComparison";
import * as g04docuGTestActions from "../../store/g04docuGTest";

const today = new Date();
// let endDate = new Date();
// endDate.setFullYear(today.getFullYear() + 2);

// 아래 form components의 name과 연계
const defaultValues = {
  id: "",
  no: "",
  name: "",
  code: "",
  // certification: [],
  // testCertification: [],
  validYN: false,
  startDate: today.getDateWithStartHours(),
  endDate: null,
  comments: "",
};

let pond;

const G04docuFileDialogEx = ({
  open,
  setOpen,
  selectedRow,
  selectedGClientId,
  selectedGClient,
  selectedGComponentItemId,
  selectedGComponentItemName,
  selectedGComponentItemType,
  setSelectedGComponentItemId,
  setSelectedGComponentItemName,
  setSelectedGComponentItemType,
  selectedDocuFileType,
  refresh,
  from,
  deleteButton = true,
}) => {

  console.log("selectedRow", selectedRow, " , selectedDocuFileType", selectedDocuFileType);

  const { control, setValue, getValues } = useForm({ defaultValues: defaultValues });
  
  // 시험성과대비표 기준정보 , DB 조회 (gtestComparisons)
  const gtestComparisons = useSelector((state) => state.gtestComparison.gtestComparisons);
  // 시험성과대비표 고객정보 , DB 조회 (g04docuGTestComparisons)
  const g04docuGTestComparisons = useSelector((state) => state.g04docuGTestComparison.g04docuGTestComparisons);
  // 사용자 권한 정보
  const sessionUserType = useSelector((state) => state.session.sessionUser.type);

  // 데이터 관리
  const dispatch = useDispatch();


  const { division, g04docuGCertificationId, g04docuGCertificationName, g04docuGTestId, g04docuGTestName, documentPath, gstandardName/*, startDate, endDate*/ } = selectedRow;

  const handleClickAdd = () => {
    const id = uuidv4();
    
    setRowsG04docuGTestComparison((oldRows) => [...oldRows, { id, item: '시험항목', unit: '단위', criterion: '기준', value: '', result: '', isNew: true }]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.View, fieldToFocus: 'item' },
    }));
  };

  // const [loading, setLoading] = useState(false);
  const [alertInfo, setAlertInfo] = useState({});
  const [originalDocumentPath, setOriginalDocumentPath] = useState(null);
  const [uploadedDocumentPath, setUploadedDocumentPath] = useState(null);
  const [fullScreen, setFullScreen] = useState(false);
  const [gtestComparisonShow, setGTestComparisonShow] = useState(false);
  const [rowsG04docuGTestComparison, setRowsG04docuGTestComparison] = useState([]);
  const [originalRowsG04docuGTestComparison, setOriginalRowsG04docuGTestComparison] = useState([]); // 원본 데이터 저장 (작업취소용)
  const [rowModesModel, setRowModesModel] = useState({});
  const [cellModesModel, setCellModesModel] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [fromGTestComparison, setFromGTestComparison] = useState(false);
  const [displayFileName, setDisplayFileName] = useState(null);
  const [hasChanges, setHasChanges] = useState(false); // 데이터 변경 여부 추적

  // local state 정의
  const [localGComponentItemId, setLocalGComponentItemId] = useState(selectedGComponentItemId);
  const [localGComponentItemName, setLocalGComponentItemName] = useState(selectedGComponentItemName);
  const [localGComponentItemType, setLocalGComponentItemType] = useState(selectedGComponentItemType);
  const [localG04docuGCertificationId, setLocalG04docuGCertificationId] = useState(g04docuGCertificationId);
  const [localG04docuGCertificationName, setLocalG04docuGCertificationName] = useState(g04docuGCertificationName);
  const [localG04docuGTestId, setLocalG04docuGTestId] = useState(g04docuGTestId);
  const [localG04docuGTestName, setLocalG04docuGTestName] = useState(g04docuGTestName);
  const [localDivision, setLocalDivision] = useState(division);
  const [localGstandardName, setLocalGstandardName] = useState(gstandardName);

  useEffect(
    () => {
      if (open) {
        initDialog();

        const currentEndDate = getValues("endDate");

        for (const [item, value] of Object.entries(defaultValues)) {
          if (item === "startDate" || item === "endDate") {
            console.log(typeof selectedRow[item]) // DB에서 받은 값은 string 타입임
            // endDate가 이미 설정되어 있으면 업데이트하지 않음
            if (item === "endDate" && currentEndDate) {
              continue;
            }
            const newValue = selectedRow[item] ? new Date(selectedRow[item]) : value;
            setValue(item, newValue);
            // if (item === "endDate") {
            //   setEndDate(newValue);
            // }
          } else {
            setValue(item, selectedRow[item] || value);
          }
        }

        // 그외 설정할 것들은 여기서 한다.
        // selectedRow["endDate"] && documentPath && setDisabled(false); // 인증서는 유효기간이 반드시 있으므로 "만료일 없음" 관련 기능 삭제
        // gtestComparisons
        
        const { g04docuGCertificationId, g04docuGTestId } = selectedRow;
        // 시험성과대비표 고객정보 조회 (g04docuGTestComparisons)
        // TODO: 성적서 저장 후 응답결과 없는 경우 시험성과대비표 조회 추가 필요
        if (g04docuGTestId) {
          selectAllByG04docuGTests(g04docuGTestId);
        }
      }

      // 서류 파일명 표시 - currentDocumentPath 는 서류저장 후 날짜 또는 서류를 재업로드 저장 하기 위해 사용
      if (documentPath) {
        setOriginalDocumentPath(documentPath);
        setDisplayFileName(documentPath.split('/').pop());
      } else {
        setDisplayFileName(null);
      }

      console.log({ originalDocumentPath, displayFileName });
    }, [selectedRow]
  );

  // Dashboard에서 서류 파일명 클릭시 실행되는 코드
  useEffect(() => {
    const fetchData = async () => {
      if (selectedDocuFileType === 'TEST' && !selectedGComponentItemId) {
        const response = await g04docuGTestActions.selectByIdDirect(g04docuGTestId);
        console.log({ gclientG04docuGTestMap: response });
        // 응답이 배열이고 데이터가 있는 경우
        if (Array.isArray(response) && response.length > 0) {
          const gclientG04docuGTestMap = response[0];

          console.log({ gclientG04docuGTestMap });

          setLocalGComponentItemId(gclientG04docuGTestMap.gcomponentItemId);
          setLocalGComponentItemName(gclientG04docuGTestMap.gcomponentItemName);
          setLocalGComponentItemType(gclientG04docuGTestMap.division);

          setLocalG04docuGCertificationName(gclientG04docuGTestMap.g04docuGCertificationName);
          setLocalG04docuGCertificationId(gclientG04docuGTestMap.g04docuGCertificationId);
          setLocalG04docuGTestName(gclientG04docuGTestMap.name);
          setLocalG04docuGTestId(gclientG04docuGTestMap.id);
          setLocalDivision(gclientG04docuGTestMap.division);
          setLocalGstandardName(gclientG04docuGTestMap.g04docuGCertificationName);

          console.log({ localGComponentItemId, localGComponentItemName, localGComponentItemType, localG04docuGCertificationId, localG04docuGCertificationName, localG04docuGTestId, localG04docuGTestName, localDivision });
        }
      }
    };
  
    if (from === 'Dashboard') {
      fetchData();
    }
  }, [selectedRow, from]);

  // Dashboard에서 서류 파일명 클릭시 실행되는 코드, NOT USED
  // useEffect(
  //   () => {
  //     const parseData = () => {
  //       // /home/warpcore/project/g04docu/동일유리(주)(15fcfdd4-e9a9-491a-bd6d-add97ec883b5)/TEST/강화유리(1a6927d0-114c-4010-993b-00f2df7e9055)/5 F___T(2a0bc077-b681-4fd3-9472-98bcd3d3c5a6)/강화_5MM.pdf
  //     // /home/warpcore/project/g04docu/동일유리(주)(15fcfdd4-e9a9-491a-bd6d-add97ec883b5)/TEST/복층유리(bc096321-bf2f-46f3-9528-dce275826ef1)/5 MVT175S H___S + 14 AR + 5 CL(KCC)(29b69921-ef5f-42ef-a8f9-08a81f8ad8cd)/KCCGLASS_공인성적서_5MVT175S(H_S) + 14Ar + 5CLR_5MVT175S(H_S) + 14Ar + 5CLR.pdf
  //       if (documentPath != null) {
  //         const pathParts = documentPath.split('/');
  //         const testIndex = pathParts.findIndex(part => part === 'TEST');
  //         if (testIndex !== -1) {
  //           // 인증서 정보 파싱
  //           const certificationPart = pathParts[testIndex + 1];
  //           const certificationMatch = certificationPart.match(/([^(]+)\(([^)]+)\)/);
  //           if (certificationMatch) {
  //             setParsedG04docuGCertificationName(certificationMatch[1]);  // "복층유리"
  //             setParsedG04docuGCertificationId(certificationMatch[2]);    // "bc096321-bf2f-46f3-9528-dce275826ef1"
  //           }
    
  //           // 시험 정보 파싱 - 수정된 부분
  //           const testPart = pathParts[testIndex + 2];
  //           // 마지막 UUID를 추출하기 위해 마지막 '/' 앞의 문자열에서 괄호 안의 내용을 찾음
  //           const testMatch = testPart.match(/(.*)\(([^)]+)\)$/);
  //           if (testMatch) {
  //             setParsedG04docuGTestName(testMatch[1]);  // "5 MVT175S H___S + 14 AR + 5 CL(KCC)"
  //             setParsedG04docuGTestId(testMatch[2]);    // "29b69921-ef5f-42ef-a8f9-08a81f8ad8cd"
  //           }
  //         }
    
  //         console.log({ 
  //           documentPath, 
  //           parsedG04docuGCertificationId, 
  //           parsedG04docuGCertificationName, 
  //           parsedG04docuGTestId, 
  //           parsedG04docuGTestName 
  //         });
  //       }
  //     }
  //     //parseData();
  //   }, [documentPath]
  // );

  
  // 시험성과대비표 기준정보 , DB 조회 (gtestComparisons)
  useEffect(
    () => {
      console.log("selectedRow", selectedRow)
      const { g04docuGTestId, division, code, selectedClassifications, sample, gstandardNo } = selectedRow;
      
      let type = "";
      if (selectedClassifications && Array.isArray(selectedClassifications)) {
        const selectedClassification = selectedClassifications.filter(c => c.checked === true);
        if (selectedClassification.length > 0) {
          type = selectedClassification[0].type;
        }
      }

      const newRowsGTestComparison = gtestComparisons.map(row => {
        const { criterion } = row;
        const selectedCriterion = GlassUtils.selectCriterion(criterion, code, type, division, sample, gstandardNo);
        return {
          ...row,
          id: uuidv4(),
          g04docuGTestId: g04docuGTestId,
          criterion: selectedCriterion,
        }
      })

      if (newRowsGTestComparison.length > 0) {
        setLoaded(false);
        setRowsG04docuGTestComparison(newRowsGTestComparison);
        setOriginalRowsG04docuGTestComparison(JSON.parse(JSON.stringify(newRowsGTestComparison))); // 깊은 복사로 원본 저장
      } else {
        setRowsG04docuGTestComparison([]);
        setOriginalRowsG04docuGTestComparison([]);
      }

      setLoaded(true);
    }, [gtestComparisons]
  )

  useEffect(
    () => {
      if (g04docuGTestComparisons.length === 0) {
        const { g04docuGCertificationId } = selectedRow;
        if (g04docuGCertificationId) {
          setFromGTestComparison(true);
          selectGTestComparisions(g04docuGCertificationId);
          
        }
      } else {
        setFromGTestComparison(false);
        console.log("g04docuGTestComparisons => ", g04docuGTestComparisons)
        const rowsWithId = g04docuGTestComparisons.map(row => ({ ...row, id: row.id || uuidv4() }));
        setRowsG04docuGTestComparison(rowsWithId);
        setOriginalRowsG04docuGTestComparison(JSON.parse(JSON.stringify(rowsWithId))); // 깊은 복사로 원본 저장
      }
    }, [g04docuGTestComparisons]
  )

  useEffect(
    () => {
      // console.log(rowsG04docuGTestComparison)
    }, [rowsG04docuGTestComparison]
  )

  // 데이터 변경 여부 확인
  useEffect(() => {
    if (originalRowsG04docuGTestComparison.length === 0 && rowsG04docuGTestComparison.length === 0) {
      setHasChanges(false);
      return;
    }

    // 데이터 길이가 다르면 변경된 것으로 간주
    if (originalRowsG04docuGTestComparison.length !== rowsG04docuGTestComparison.length) {
      setHasChanges(true);
      return;
    }

    // 각 행의 데이터를 비교
    const hasDataChanges = rowsG04docuGTestComparison.some((currentRow, index) => {
      const originalRow = originalRowsG04docuGTestComparison[index];
      if (!originalRow) return true;

      // 비교할 필드들
      const fieldsToCompare = ['item', 'unit', 'criterion', 'value', 'result', 'method'];
      
      return fieldsToCompare.some(field => {
        const currentValue = currentRow[field];
        const originalValue = originalRow[field];
        return currentValue !== originalValue;
      });
    });

    setHasChanges(hasDataChanges);
  }, [rowsG04docuGTestComparison, originalRowsG04docuGTestComparison]);

  // 실제 사용할 current 값 정의
  const currGComponentItemId = selectedGComponentItemId || localGComponentItemId;
  const currGComponentItemName = selectedGComponentItemName || localGComponentItemName;
  const currGComponentItemType = selectedGComponentItemType || localGComponentItemType;
  const currG04docuGCertificationId = g04docuGCertificationId || localG04docuGCertificationId;
  const currG04docuGCertificationName = g04docuGCertificationName || localG04docuGCertificationName;
  const currG04docuGTestId = g04docuGTestId || localG04docuGTestId;
  const currG04docuGTestName = g04docuGTestName || localG04docuGTestName;
  const currDivision = division || localDivision;
  const currGstandardName = localGstandardName || gstandardName;

  const handleClickG04docuGTestComparison = async () => {
    setLoaded(false);
    
    if (rowsG04docuGTestComparison.length <= 0) {
      alert("시험항목이 없습니다. 시험항목을 추가해주세요.");
      setTimeout(() => setLoaded(true), 300);
      return;
    }

    const { selectedClassifications } = selectedRow;
    let classification = "";
    if (selectedClassifications && Array.isArray(selectedClassifications)) {
      const selectedClassification = selectedClassifications.filter(c => c.checked === true);
      if (selectedClassification.length > 0) {
        classification = selectedClassification[0].type;
      }
    }

    try {
      await createG04docuGTestComparisonsBulk({
        g04docuGTestId: currG04docuGTestId,
        g04docuGTestName: currG04docuGTestName,
        division: currDivision,
        g04docuGTestComparisons: rowsG04docuGTestComparison.map(row => {
          delete row.g04docuGCertificationId;
          delete row.gstandardId; // gstandardId도 제거
          return row;
        }),
        gclientId: selectedGClientId,
        gcomponentItemId: currGComponentItemId,
        gcomponentItemName: currGComponentItemName,
        g04docuGCertificationId: currG04docuGCertificationId,
        g04docuGCertificationName: currG04docuGCertificationName,
        gclient: selectedGClient,
        classification,
      });

      // 저장 완료 시 변경사항 초기화
      setHasChanges(false);

      setAlertInfo({
        titleAlert: "안내",
        messageAlert: (
          <div>
            <span style={{ color: "#1976d2" }}>{"시험성과대비표"}</span><span>{"가 작성되었습니다."}</span>
            <br /><br />
            <Box sx={{ solid: 1, borderRadius: 1, bgcolor: '#eee', color: '#aaa', p: 1, fontSize: '0.8em' }}>
              { `제품명(성적서명) : ${currGComponentItemName || ''} ${currG04docuGTestName}` }
            </Box>
          </div>
        ),
        open: true,
      });

      setTimeout(() => setLoaded(true), 300);

      if (from === 'PROFILE') {
        division === 'PROCESS' ? refresh(selectedGClientId) : refresh(selectedGClientId, division);
      } else {
        refresh(selectedGComponentItemType === 'PROCESS' ? g04docuGCertificationId : selectedGComponentItemId, selectedGComponentItemType, selectedGClientId);
      }

    } catch (error) {
      // 오류 발생 시 메시지
      setAlertInfo({
        titleAlert: "오류",
        messageAlert: (
          <div>
            <span style={{ color: "#d32f2f" }}>{"시험성과대비표 작성에 실패했습니다."}</span>
            <br />
            <span style={{ fontSize: '0.9em', color: '#666' }}>
              {error.message || "알 수 없는 오류가 발생했습니다."}
            </span>
          </div>
        ),
        open: true,
      });

      // 오류 발생 시에도 로딩 상태 해제
      setLoaded(true);
    }
  }

  // 시험성과대비표 초기화 , DB 조회 (g04docuGCcertifications)
  const handleClickInitG04docuGTestComparison = () => {
    const { g04docuGCertificationId } = selectedRow;
    if (g04docuGCertificationId || currG04docuGCertificationId) {
      selectGTestComparisions(g04docuGCertificationId || currG04docuGCertificationId)
    }
  }

  // 시험성과대비표 작업취소 - 사용자가 수정한 내용을 원본으로 되돌림
  const handleClickSearchG04docuGTestComparison = () => {
    if (originalRowsG04docuGTestComparison.length > 0) {
      setRowsG04docuGTestComparison(JSON.parse(JSON.stringify(originalRowsG04docuGTestComparison)));
      setHasChanges(false); // 변경사항 초기화
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: "수정한 내용이 원래의 상태로 되돌려졌습니다.",
        open: true,
      });
    } else {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: "되돌릴 원본 데이터가 없습니다.",
        open: true,
      });
    }
  }

  const handleClickAnalyzeG04docuGTestComparison = async () => {
    const jsonData = prepareTestComparisonData(selectedRow, division);
    console.log(jsonData);
    const results = await gclientG04docuGTestMapActions.selectResultsFromGTestDocumentDirect(selectedGClientId, currG04docuGTestId, jsonData);
    if (results?.g04docuGTestComparisons && Array.isArray(results.g04docuGTestComparisons)) {
      if (results.extractType === 'QR') {
        const newRows = results.g04docuGTestComparisons.map(row => ({
          ...row,
          id: row.id || uuidv4(),
        }));
        setRowsG04docuGTestComparison(newRows);
        setOriginalRowsG04docuGTestComparison(JSON.parse(JSON.stringify(newRows)));
      } else {
        alert("성적서 분석 실패");
      }
    }
  }

  // DataGridPro 내 툴바 사용할 경우 셀 수정 후 포커스를 잃어야 버튼이 동작한다. 따라서 EditToolbar 사용하지 않고 그리드 밖에 버튼을 만들어 사용
  // const EditToolbar = (props) => {
  //   const { setRows, setRowModesModel, rows } = props;
  
  //   const handleClickAdd = () => {
  //     const id = uuidv4();
      
  //     setRows((oldRows) => [...oldRows, { id, item: '시험항목', unit: '단위', criterion: '기준', value: '', result: '', isNew: true }]);
  //     setRowModesModel((oldModel) => ({
  //       ...oldModel,
  //       [id]: { mode: GridRowModes.Edit, fieldToFocus: 'item' },
  //     }));
  //   };
  
  //   // 시험성과대비표 DB 저장
  //   const handleClickSaveG04docuGTestComparison = async () => {
  //     setLoaded(false);
  //     await createG04docuGTestComparisonsBulk({
  //       g04docuGTestId,
  //       g04docuGTestName,
  //       division,
  //       g04docuGTestComparisons: rowsG04docuGTestComparison,
  //       gclientId: selectedGClientId,
  //       gcomponentItemId: selectedGComponentItemId,
  //       gcomponentItemName: selectedGComponentItemName,
  //       g04docuGCertificationId,
  //       g04docuGCertificationName,
  //       gclient: selectedGClient,
  //     });

  //     setAlertInfo({
  //       titleAlert: "안내",
  //       messageAlert: (
  //         <div>
  //           <span style={{ color: "#1976d2" }}>{"시험성과대비표"}</span><span>{"가 작성되었습니다."}</span>
  //           <br /><br />
  //           <Box sx={{ solid: 1, borderRadius: 1, bgcolor: '#eee', color: '#aaa', p: 1, fontSize: '0.8em' }}>
  //             { `제품명 : ${selectedGComponentItemName} ${g04docuGTestName}` }
  //           </Box>
  //         </div>
  //       ),
  //       open: true,
  //     });

  //     setTimeout(() => setLoaded(true), 300);

  //     if (from === 'PROFILE') {
  //       division === 'PROCESS' ? refresh(selectedGClientId) : refresh(selectedGClientId, division);
  //     } else {
  //       refresh(selectedGComponentItemType === 'PROCESS' ? g04docuGCertificationId : selectedGComponentItemId, selectedGComponentItemType, selectedGClientId);
  //     }
  //   }

  //   // 시험성과대비표 초기화 , DB 조회 (초기화)
  //   const handleClickInitG04docuGTestComparison = () => {
  //     const { g04docuGCertificationId } = selectedRow;
  //     if (g04docuGCertificationId) {
  //       selectGTestComparisions(g04docuGCertificationId)
  //     }
  //   }

  //   // 다시불러오기
  //   const handleClickSearchG04docuGTestComparison = () => {
  //     const { g04docuGTestId } = selectedRow;
  //     if (g04docuGTestId) {
  //       selectAllByG04docuGTests(g04docuGTestId)
  //     }
  //   }
  
  //   const { gstandardNo, guideLink } = selectedRow;
  //   const GuideLink = guideLink ? (
  //     <Tooltip title={guideLink}>
  //       <Button
  //         startIcon={<CommentBank />}
  //         >
  //         <Link
  //           href={guideLink}
  //           underline="none"
  //           target="_blank"
  //           rel="noopener"
  //         > 
  //           {`${gstandardNo} 규격집`}
  //         </Link>
  //       </Button>
  //     </Tooltip>
  //   ) : <></>;

  //   return (
  //     <GridToolbarContainer>
  //       <Tooltip title="시험항목을 추가합니다.">
  //         <Button color="primary" startIcon={<Add />} onClick={handleClickAdd}>
  //           {"추가"}
  //         </Button>
  //       </Tooltip>
  //       <Tooltip title="시험결과를 저장하고 시험성과대비표를 작성합니다.">
  //         <Button color="primary" startIcon={<Save />} onClick={handleClickSaveG04docuGTestComparison}>
  //           {"저장/작성"}
  //         </Button>
  //       </Tooltip>
  //       <Tooltip title="표준 시험항목을 불러옵니다.">
  //         <Button color="primary" startIcon={<Undo />} onClick={handleClickInitG04docuGTestComparison}>
  //           {"초기화"}
  //         </Button>
  //       </Tooltip>
  //       <Tooltip title="마지막으로 작성한 시험성과대비표를 불러옵니다.">
  //         <Button color="primary" startIcon={<Refresh />} onClick={handleClickSearchG04docuGTestComparison}>
  //           {"다시불러오기"}
  //         </Button>
  //       </Tooltip>
  //       {GuideLink}
  //     </GridToolbarContainer>
  //   );
  // }

  
  // const [errors, setErrors] = useState([]);
  const [files, setFiles] = useState(
    []
    // [{
    //   source: "https://www.google.com/logos/doodles/2018/baba-amtes-104th-birthday-6729609885253632-s.png",
    //   options:{
    //         type: 'remote'
    //   }
    // }],
  );
  

  // 시험성과대비표 그리드 화면 클릭 이벤트 처리
  const handleCellClick = useCallback((params, event) => {
    // office 속성이 있는 행은 클릭 처리하지 않음
    // if (params.row.office) {
    //   return;
    // }
    // 편집 불가능한 셀은 처리하지 않음
    if (!params.isEditable) {
      return;
    }

    // 현재 셀이 이미 편집 모드인지 확인
    // const isCurrentCellInEditMode = cellModesModel[params.id]?.[params.field]?.mode === GridCellModes.Edit;
    // 이미 편집 모드인 경우 아무 동작하지 않음
    // if (isCurrentCellInEditMode) {
    //   return;
    // }

    // Ignore portal
    if (event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) {
      return;
    }

    setCellModesModel((prevModel) => {      
      const newModel = {
        // Revert the mode of the other cells from other rows
        ...Object.keys(prevModel).reduce(
          (acc, id) => ({
            ...acc,
            [id]: Object.keys(prevModel[id]).reduce(
              (acc2, field) => ({
                ...acc2,
                [field]: { mode: GridCellModes.View },
              }),
              {},
            ),
          }),
          {},
        ),
        [params.id]: {
          // Revert the mode of other cells in the same row
          ...Object.keys(prevModel[params.id] || {}).reduce(
            (acc, field) => ({ ...acc, [field]: { mode: GridCellModes.View } }),
            {},
          ),
          [params.field]: { mode: GridCellModes.Edit },
        },
      };
      return newModel;
    });
  }, []);

  const handleCellModesModelChange = useCallback((newModel) => {
    console.log("handleCellModesModelChange");
    console.log(newModel)
    setCellModesModel(newModel);
  }, []);

  const handleCellKeyDown = (params, event) => {
    if (event.key === 'Enter') {
      // Enter 키 입력 시 편집 모드 종료
      const updatedRow = { ...params.row, [params.field]: event.target.value };
      processRowUpdate(updatedRow);
      
      // 편집 모드 종료
      setCellModesModel((prevModel) => ({
        ...prevModel,
        [params.id]: {
          ...prevModel[params.id],
          [params.field]: { mode: GridCellModes.View }
        }
      }));
    }
  };

  const handleDeleteClick = (id) => () => {
    setRowsG04docuGTestComparison(rowsG04docuGTestComparison.filter((row) => row.id !== id));
  };

  const updateRowPosition = (initialIndex, newIndex, rows) => {
    return new Promise((resolve) => {
      setTimeout(
        () => {
          const rowsClone = [...rows];
          const row = rowsClone.splice(initialIndex, 1)[0];
          rowsClone.splice(newIndex, 0, row);
          resolve(rowsClone);
        }, 300,
      );
    });
  }

  const handleRowOrderChange = async (params) => {
    // setLoading(true);
    const newRows = await updateRowPosition(
      params.oldIndex,
      params.targetIndex,
      rowsG04docuGTestComparison,
    );

    // setRowsG04docuGTestComparison(newRows.map(row => {
    //   return {
    //     ...row,
    //     id: uuidv4(),
    //   }
    // }));
    setRowsG04docuGTestComparison(newRows);
    // setLoading(false);
  };

  const processRowUpdate = React.useCallback((newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRowsG04docuGTestComparison(prevRows => 
      prevRows.map((row) => (row.id === newRow.id ? updatedRow : row))
    );
    return updatedRow;
  }, []);

  // 시험성과대비표 미저장 알림 메시지 표시 함수
  const showTestComparisonNotSavedAlert = () => {
    setAlertInfo({
      titleAlert: "안내",
      messageAlert: (<div>
        <span>{"시험성과대비표가 작성되지 않은 상태입니다."}</span><br/>
        {
          !gtestComparisonShow ?
            <span>
              {"지금 작성하시려면 "}<span style={{ color: '#1976d2' }}>{"취소"}</span>{"를 눌러 이 창을 닫고,"}<br />
              <span style={{ color: '#1976d2' }}>{"시험성과대비표 만들기"}</span>{"를 눌러 시험성과대비표를 작성해 주세요."}<br />
              {"다음에 작성하시려면 "}<span style={{ color: '#1976d2' }}>{"나중에"}</span>{"를 눌러주세요."}
            </span> :
            <span>
              {"지금 작성하시려면 "}<span style={{ color: '#1976d2' }}>{"취소"}</span>{"를 눌러 이 창을 닫고,"}<br />
              {"시험성과대비표 목록 상단의 "}<span style={{ color: '#1976d2' }}>{"저장"}</span>{"을 클릭하여 시험성과대비표 작성을 완료해 주세요."}<br />
              {"다음에 작성하시려면 "}<span style={{ color: '#1976d2' }}>{"나중에"}</span>{"를 눌러주세요."}
            </span>
        }
      </div>),
      type: 'confirm',
      open: true,
      confirmText: "나중에",
      cancelText: "취소",
      handleConfirm: () => {
        setOpen(false);
        initDialog();
      }
    });
  };

  const handleDialogClose = async() => {
    if (uploadedDocumentPath) {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: (
          <div>
            <span>{"현재 서류가 저장되지 않은 상태입니다."}</span>
            <br/>
            <span>{"["}<span style={{ color: '#1976d2' }}>{"서류저장"}</span>{"] 버튼을 클릭하여 서류첨부를 완료해 주세요."}</span>
          </div>
        ),
        open: true,
      });
      return;
    }

    // 시험성과대비표는 성적서(TEST)에만 해당하며, 서류저장이 완료된 후에만 검증
    if (selectedDocuFileType === 'TEST' && originalDocumentPath) {
      // 시험성과대비표 만들지 않은 경우 알림 메시지. TODO : 시험성과대비표 문서가 있는지 확인 필요
      try {
        const gclientG04docuGTestComparisonMap = await g04docuGTestComparisonActions.selectByGClientIdAndG04docuGTestIdDirect(selectedGClientId, currG04docuGTestId);
        if (!(gclientG04docuGTestComparisonMap && !!gclientG04docuGTestComparisonMap.documentPath)) {
          showTestComparisonNotSavedAlert();
          return;
        }
      } catch (error) {
        // serverResponse : {
        //   "code": 12047,
        //   "title": "Server Error",
        //   "message": "시험성과대비표 문서정보가 존재하지 않습니다."
        // }
        console.log({ error })
        if (error?.serverResponse?.code === 12047) {
          showTestComparisonNotSavedAlert();
          return;
        }
      }
    }

    setOpen(false);
    initDialog();
  };

  const initDialog = () => {
    for (const [item, value] of Object.entries(defaultValues)) {
      setValue(item, value);
    }

    // 그외 초기화할 것들은 여기서 초기화
    if (pond) {
      pond.removeFiles();
    }
    setFiles([]);
    setFullScreen(false);
    setGTestComparisonShow(false);
    setRowsG04docuGTestComparison([]);
    setOriginalRowsG04docuGTestComparison([]);
    setHasChanges(false);
    
    setFromGTestComparison(false);

    setLocalGComponentItemId(null);
    setLocalGComponentItemName(null);
    setLocalGComponentItemType(null);
    setLocalG04docuGCertificationId(null);
    setLocalG04docuGCertificationName(null);
    setLocalG04docuGTestId(null);
    setLocalG04docuGTestName(null);
    setLocalDivision(null);
    setLocalGstandardName(null);

    setDisplayFileName(null);
    setOriginalDocumentPath(null);
    setUploadedDocumentPath(null);

    // setIsConfirmed(false);
  }

  
  const createGClientG04docuGCertificationMap = ({ gclientId, g04docuGCertificationId, gcomponentItemId, gclient, documentPath, documentType, validYN, startDate, endDate }) => dispatch(gclientG04docuGCertificationMapActions.create({ gclientId, g04docuGCertificationId, gcomponentItemId, gclient, documentPath, documentType, validYN, startDate, endDate }))
  const updateGClientG04docuGCertificationMap = ({ gclientId, g04docuGCertificationId, newDocumentPath, documentPath, validYN, startDate, endDate }) => dispatch(gclientG04docuGCertificationMapActions.modifyDate({ gclientId, g04docuGCertificationId, newDocumentPath, documentPath, validYN, startDate, endDate }))
  const removeGClientG04docuGCertificationMap = ({ gclientId, g04docuGCertificationId, documentPath }) => dispatch(gclientG04docuGCertificationMapActions.remove({ gclientId, g04docuGCertificationId, documentPath }))

  const createGClientG04docuGTestMap = ({ gclientId, g04docuGTestId, gcomponentItemId, g04docuGCertificationId, gclient, documentPath, documentType, validYN, startDate, endDate }) => dispatch(gclientG04docuGTestMapActions.create({ gclientId, g04docuGTestId, gcomponentItemId, g04docuGCertificationId, gclient, documentPath, documentType, validYN, startDate, endDate }))
  const updateGClientG04docuGTestMap = ({ gclientId, g04docuGTestId, newDocumentPath, documentPath, validYN, startDate, endDate }) => dispatch(gclientG04docuGTestMapActions.modifyDate({ gclientId, g04docuGTestId, newDocumentPath, documentPath, validYN, startDate, endDate }))
  const removeGClientG04docuGTestMap = ({ gclientId, g04docuGTestId, documentPath }) => dispatch(gclientG04docuGTestMapActions.remove({ gclientId, g04docuGTestId, documentPath }))

  const downloadG04docuFile = (documentPath) => g04docuFileActions.downloadDirect(documentPath)
  const removeG04docuFile = (documentPath) => g04docuFileActions.removeDirect(documentPath)

  // 시험성과대비표 item, unit, criterion, value, result, method 정보 조회
  const selectGTestComparisions = (g04docuGCertificationId) => dispatch(gtestComparisonActions.selectAllByG04docuGCertifications(g04docuGCertificationId))
  const selectAllByG04docuGTests = (g04docuGTestId) => dispatch(g04docuGTestComparisonActions.selectAllByG04docuGTests(g04docuGTestId))
  const createG04docuGTestComparisonsBulk = ({
    g04docuGTestId,
    g04docuGTestName,
    division,
    g04docuGTestComparisons,
    gclientId,
    gcomponentItemId,
    gcomponentItemName,
    g04docuGCertificationId,
    g04docuGCertificationName,
    gclient,
    classification,
  }) => dispatch(g04docuGTestComparisonActions.createG04docuGTestComparisonsBulk({
    g04docuGTestId,
    g04docuGTestName,
    division,
    g04docuGTestComparisons,
    gclientId,
    gcomponentItemId,
    gcomponentItemName,
    g04docuGCertificationId,
    g04docuGCertificationName,
    gclient,
    classification,
  }))

  const columnsGTestComparison = [ // 정렬없음
    {
      field: 'item',
      headerName: '구분',
      editable: (params) => !params.row.office,
      width: 160,
    },
    {
      field: 'unit',
      headerName: '단위',
      editable: (params) => !params.row.office,
      width: 100,
    },
    {
      field: 'criterion',
      headerName: '기준',
      editable: true,
      width: 300,
      renderCell: (params) => {
        if (params.row.noDetailCriterion) {
          return (
            <Tooltip title={params.row.noDetailCriterion}>
              <span style={{ color: '#DB4E2E', fontWeight: 'bold' }}>{params.value}</span>
            </Tooltip>
          );
        }
        return params.value;
      }
    },
    {
      field: 'value',
      headerName: '시험결과',
      editable: (params) => !params.row.office,
      width: 120,
    },
    {
      field: 'result',
      headerName: '판정',
      width: 120,
      editable: true,
      type: 'singleSelect',
      valueOptions: ['합격', '불합격', '참조값'],
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        if (params.value === '합격') {
          return <span style={{ color: '#1976d2', fontWeight: 'bold' }}>합격</span>;
        }
        if (params.value === '불합격') {
          return <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>불합격</span>;
        }
        return params.value;
      }
    },
    {
      field: 'method',
      headerName: '시험방법',
      editable: true,
      width: 120,
    },
    {
      field: 'office',
      headerName: '시험기관',
      hide: true,
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: '기능',
      width: 87,
      cellClassName: 'actions',
      getActions: ({ id, row }) => {
        // office가 있으면 빈 배열 반환하여 아이콘 숨김
        if (row.office) {
          return [];
        }
        return [
          <GridActionsCellItem
            icon={<Delete />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
    // {
    //   field: 'functions',
    //   headerName: '기능',
    //   headerAlign: 'center',
    //   align: 'center',
    //   renderCell: (params) => {          
    //     const buttons = [
    //       // <IconButton size="small" ><OpenInNew /></IconButton>,
    //       <IconButton size="small" onClick={(e) => handleSelectGTestComparison(e, { type: 'edit', params })}><Edit /></IconButton>,
    //       <IconButton size="small" onClick={(e) => handleSelectGTestComparison(e, { type: 'delete', params })}><Delete /></IconButton>,
    //     ];
        
    //     return buttons;
    //   }
    // },
  ];

  
  // return 값에 유의. true => 값 변경, false => 현재값 유지
  const handleChangePeriod = (value, name) => {
    console.log({ name, value })
    // if ((documentPath || uploadedDocumentPath) && (name === "endDate" ? value : getValues("endDate"))) {
    //   setDisabled(false);
    // } else {
    //   setDisabled(true);
    // }
    setValue(name, value);
    setValue("validYN", false);
    // if (name === "endDate") {
    //   setEndDate(value);
    // }
    return true;
  }

  // 삭제 버튼 핸들러
  const handleClickDelete = async () => {
    setAlertInfo({
      titleAlert: "안내",
      messageAlert: "서류를 삭제하시겠습니까?",
      type: 'confirm',
      open: true,
      confirmText: "예",
      cancelText: "아니오",
      handleConfirm: async () => {

        console.log("handleClickDelete : ", {documentPath, originalDocumentPath});

        if (selectedDocuFileType === 'CERTIFICATION') {
          await removeGClientG04docuGCertificationMap({ 
            gclientId: selectedGClientId, 
            g04docuGCertificationId: currG04docuGCertificationId,
            documentPath: originalDocumentPath
          });
        } else if (selectedDocuFileType === 'TEST') {
          await removeGClientG04docuGTestMap({ 
            gclientId: selectedGClientId, 
            g04docuGTestId: currG04docuGTestId,
            documentPath: originalDocumentPath
          });
        }
        if (documentPath) {
          await removeG04docuFile(originalDocumentPath);
        }
        
        // refresh 호출
        refreshG04docuFile();
        initDialog();
        setOpen(false);
      }
    });
  };

  const formatDateToKorean = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}년 ${month}월 ${day}일`;
  };

  // 파일 첨부 후 저장 버튼 클릭
  const handleClickSave = (mode) => {
    const startDate = getValues("startDate")? dateFormat(getValues("startDate").getDateWithStartHours()) : null;
    const endDate = getValues("endDate") ? dateFormat(getValues("endDate").getDateWithEndHours()) : null;
    const validYN = endDate ? false : true;
    const today = new Date().setHours(0,0,0,0);
    const displayEndDate = formatDateToKorean(endDate);
    const displayToday = formatDateToKorean(today);
  
    // 신규는 서류를 첨부
    if (!originalDocumentPath && !uploadedDocumentPath) {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: "서류가 첨부되지 않았습니다. 서류를 첨부해 주세요.",
        open: true
      });
      return;
    }

    if (!endDate) {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: "서류 만료일을 입력해주세요.",
        open: true
      });
      return;
    }

    // endDate가 현재일보다 작은지 체크
    //if (endDate && new Date(endDate) < today) {
    if (false) {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: (
          <div>
            <span style={{color: 'blue'}}>서류 만료일({displayEndDate})</span>은 <span style={{color: 'red'}}>현재일({displayToday})</span> 보다 이전일 수 없습니다.
          </div>
        ),
        open: true
      });
      return;
    }

    try {
      if (endDate) {
        setAlertInfo({
          titleAlert: "안내", 
          messageAlert: (
            <div>
              {/* 만료일만 수정일 경우 */}
              {originalDocumentPath && !uploadedDocumentPath ? (
              <div>
                <div>서류 만료일은 <span style={{color: 'blue'}}>{displayEndDate}</span> 입니다.</div>
                <div style={{paddingTop: '10px'}}>서류를 첨부하지 않고 만료일만 수정하시겠습니까?</div>
              </div>
              ) : (
              <div>
                <div>서류 만료일은 <span style={{color: 'blue'}}>{displayEndDate}</span> 입니다.</div>
                <div style={{paddingTop: '10px'}}>서류(<span style={{color: 'blue'}}>{displayFileName}</span>)를 저장하시겠습니까?</div>
              </div>
            )}
            </div>
          ),
          type: 'confirm',
          open: true,
          confirmText: "예",
          cancelText: "아니오",
          handleConfirm: async () => {
            handleClickSaveAction(startDate, endDate, validYN);
          }
        });
      } else {
        // 만료일 없음
        setAlertInfo({
          titleAlert: "안내",
          messageAlert: (
            <div>
              <div style={{paddingTop: '10px'}}>서류(<span style={{color: 'blue'}}>{displayFileName}</span>)를 저장하시겠습니까?</div>
            </div>
          ),
          type: 'confirm',
          open: true,
          confirmText: "예",
          cancelText: "아니오",
          handleConfirm: async () => {
            handleClickSaveAction(startDate, null, validYN);
          }
        });
      }
    } catch (error) {
      console.error('Error saving document:', error);
    }

    // server option의 process 시작됨. 단, 상태에 따라 process 실행여부를 자동으로 판단하므로 파일이 첨부되어 있는 경우 server option의 process 실행안함
    /*
    pond.processFiles().then(async (res) => {
      console.log({ res })
      let result = true;
      if (res.length === 0) { // 이미 파일이 첨부되어 있는 상태에서는 만료일 관련 정보만 업데이트 한다.
        result = await updateDate();
      }
  
      if (mode === 'close' && result) {
        setTimeout(() => handleDialogClose(), 300);
      }
    });*/
  }

  const refreshG04docuFile = () => {

    if (selectedDocuFileType === 'CERTIFICATION') {
      refresh(selectedGClientId);
    } else if (selectedDocuFileType === 'TEST') {
      if (from === 'PROFILE') {
        division === 'PROCESS' ? refresh(selectedGClientId) : refresh(selectedGClientId, division);
      } else {
        refresh(selectedGComponentItemType === 'PROCESS' ? g04docuGCertificationId : selectedGComponentItemId, selectedGComponentItemType, selectedGClientId);
      }
    }
  }

  const handleClickSaveAction = async (startDate, endDate, validYN) => {
    console.log("handleClickSaveAction : ", {selectedDocuFileType, g04docuGCertificationId, g04docuGTestId, endDate, validYN, originalDocumentPath, uploadedDocumentPath});
    try {
      // 수정
      if (originalDocumentPath) {
        if (selectedDocuFileType === 'CERTIFICATION') {
          const result = await updateGClientG04docuGCertificationMap({
            gclientId: selectedGClientId,
            g04docuGCertificationId,
            newDocumentPath: uploadedDocumentPath,
            documentPath: originalDocumentPath||uploadedDocumentPath,
            validYN: validYN,
            startDate: startDate, 
            endDate: endDate,
          });
          // 다이알로그 닫기
          //handleDialogClose();
        } else if (selectedDocuFileType === 'TEST') {
          const result = await updateGClientG04docuGTestMap({
            gclientId: selectedGClientId,
            g04docuGTestId,
            newDocumentPath: uploadedDocumentPath,
            documentPath: originalDocumentPath||uploadedDocumentPath,
            validYN: validYN,
            startDate: startDate, 
            endDate: endDate,
          });

          
        }
      } 
      // 신규
      else {
        if (selectedDocuFileType === 'CERTIFICATION') {
          await createGClientG04docuGCertificationMap({
            gclientId: selectedGClientId,
            g04docuGCertificationId, 
            gcomponentItemId: null,
            gclient: selectedGClient,
            documentPath: uploadedDocumentPath,
            documentType: selectedDocuFileType,
            validYN: validYN,
            startDate: startDate,
            endDate: endDate,
          });

        } else if (selectedDocuFileType === 'TEST') {
          await createGClientG04docuGTestMap({
            gclientId: selectedGClientId,
            g04docuGTestId,
            gcomponentItemId: selectedGComponentItemId,
            g04docuGCertificationId,
            gclient: selectedGClient,
            documentPath: uploadedDocumentPath,
            documentType: selectedDocuFileType,
            validYN: validYN,
            startDate: startDate,
            endDate: endDate,
          });
        }
      }

      //setIsConfirmed(true);
      // 파일 업로드 초기화
      if (uploadedDocumentPath)  {
        setOriginalDocumentPath(uploadedDocumentPath);
        setUploadedDocumentPath("");
      }
      setValue("endDate", new Date(endDate)); // endDate 유지
    
      // refresh 호출
      refreshG04docuFile();

      // 성공 메시지 표시
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: (
          <div>
            <span>{"서류저장이 성공 되었습니다."}</span>
          </div>
        ),
        open: true
      });

      if (selectedDocuFileType === 'CERTIFICATION') {
        initDialog();
        setOpen(false);
      } 

    } catch (error) {
      console.error('Error saving document:', error);
      // 실패 메시지 표시
      setAlertInfo({
        titleAlert: "오류",
        messageAlert: (
          <div>
            <span style={{ color: "#d32f2f" }}>{"서류저장에 실패했습니다."}</span>
            <br />
            <span style={{ fontSize: '0.9em', color: '#666' }}>{error.serverResponse?.message}</span>
          </div>
        ),
        open: true,
      });
    }
  }

  // 시험성과대비표 화면 출력
  const handleClickG04docuTestComparison = () => {
    if (uploadedDocumentPath) {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: (
          <div>
            <span>{"현재 서류가 저장되지 않은 상태입니다."}</span>
            <br/>
            <span>{"["}<span style={{ color: '#1976d2' }}>{"서류저장"}</span>{"] 버튼을 클릭하여 서류첨부를 완료해 주세요."}</span>
          </div>
        ),
        open: true,
      });
      return;
    }
    //setFiles([]); // 다이얼로그 풀스크린하면 FilePond를 다시 로딩함. 이때 파일첨부 부분 표시문제로 여기서 초기화하고 useEffect([fullScreen])에서 다시 setFiles 실행
    setGTestComparisonShow(!gtestComparisonShow);
    setFullScreen(!fullScreen);
  }
  
  const handleCellEditCommit = (params) => {
    const { id, field, value } = params;
    setRowsG04docuGTestComparison(prevRows => 
      prevRows.map(row => 
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  // 시험성과대비표 자동작성을 위한 데이터 준비
  const prepareTestComparisonData = (selectedRow, division) => {
    const { code, sample, selectedClassifications, gstandardNo } = selectedRow;
    let classification = "";
    let classificationFT = "";
    if (selectedClassifications && Array.isArray(selectedClassifications)) {
      const selectedClassification = selectedClassifications.filter(c => c.checked === true);
      if (selectedClassification.length > 0) {
        classification = selectedClassification[0].type;
        classificationFT = selectedClassification[0].detail.type0;
      }
    }

    let ks2012_thickness_except = false; // 복층유리
    let ks2004_thickness_arr = []; // 접합유리
    let thickness = 0;
    let spacerCount = 0;
    let maxGlassThickness = 0;

    if (division === 'RAW_MATERIAL') {
      try {
        thickness = Number(code);
      } catch (e) {
        thickness = 0;
      }
    } else if (division === 'PROCESS' && sample && sample.details && sample.details.selectedGcomponentItems) {
      sample.details.selectedGcomponentItems.forEach((gtypeDetails, i) => {
        gtypeDetails.forEach((item, j) => {
          if (j === 0) { // 각 레이어의 첫번째는 상세 구성요소의 상위 개념 (예를 들면 유리원판, 중공층 등...)으로 스킵
            return;
          }
          
          const { code, value } = item;
          if (code === 'GL THICKNESS' || code === 'SPACER THICKNESS' || code === 'FILM THICKNESS') { // <<<주의 : 코드 하드코딩 사용>>>
            const { code: valueCode } = value;
            try {
              thickness = Number((thickness + Number(valueCode)).toFixed(2)); // 소수점 2자리까지 표시
              
              // KS L 2003 규격 체크
              if (gstandardNo === 'KS L 2003') {
                if (code === 'SPACER THICKNESS') {
                  spacerCount++;
                } else if (code === 'GL THICKNESS') {
                  const glassThickness = Number(valueCode);
                  maxGlassThickness = Math.max(maxGlassThickness, glassThickness);
                }
              } else if (gstandardNo === 'KS L 2004') {
                if (code === 'GL THICKNESS' || code === 'FILM THICKNESS') { // <<<주의 : 코드 하드코딩 사용>>>
                  ks2004_thickness_arr.push(valueCode);
                }
              }
            } catch (e) {
              thickness = thickness + 0;
            }
          }
        })
      })

      // KS L 2003 규격에서 중공층이 2개 이상이거나 유리 두께가 15mm 이상인 경우
      if (gstandardNo === 'KS L 2003' && (spacerCount >= 2 || maxGlassThickness >= 15)) {
        ks2012_thickness_except = true;
      }
    }

    /**
     * TODO : 접합유리의 경우 무늬유리(KS L 2005)가 있다면 만곡이 0.5% 이하이고 그 외에는 0.3% 이하임
     * ks_2004_curve로 무늬유리여부를 추가하고 싶으나, 접합유리 성적서 취득할때는 보통 원판을 스펙인하지 않으므로 알 수 없어
     * 기준에 텍스트로만 표시 => 0.3%이하(무늬유리포함시0.5%이하)
     */
    return {
      thickness: gstandardNo === 'KS L 2003' && ks2012_thickness_except ? -1 : thickness,
      classification: classification || "no_classification",
      ft_thick_class: (thickness !== undefined && thickness !== null && classificationFT) ? `${thickness}_${classificationFT}` : "", // TODO : 추후 ks2002_thick_class로 변경할 것 (leadField 변경 필요)
      ks2004_thickness: ks2004_thickness_arr.length > 0 ? ks2004_thickness_arr.join('_') : "",
      // ks_2004_curve,
    };
  };

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleDialogClose();
          }
        }}
        PaperComponent={!fullScreen && PaperComponent} // fullScreen일때는 드래그 허용하지 않음
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        scroll="body"
        maxWidth="sm"
        disableEscapeKeyDown={true}
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              handleDialogClose();
            }
          }}
          fullScreen={fullScreen}
          color={fullScreen ? "white" : ""}
          // style={{ cursor: 'move' }}
          style={{ cursor: fullScreen ? '' : 'move', backgroundColor: fullScreen ? "#1976d2" : "" }}
        >
          {/* {"자재승인서류 첨부"} */}
          {selectedDocuFileType === 'CERTIFICATION' ? `${g04docuGCertificationName} 인증서 첨부` : `(${currGstandardName}) ${g04docuGTestName} 성적서 첨부`}
        </DialogTitleClose>
        <DialogContent>
          {/* TODO : 추후 에러메시지 노출 어떻게 할지 검토 */}
          {/* <ul>
            {errors.map((error, idx) => <li key={idx}>{error}</li>)}
          </ul> */}
          {!gtestComparisonShow && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <FormInputDate
                      name="endDate"
                      control={control}
                      label={"서류 만료일"}
                      onChangePeriodValue={handleChangePeriod}
                      value={getValues("endDate")}
                      // value={endDate}
                      setValue={setValue}
                      getValues={getValues}
                      inputHeight={38}
                      clearable={true}
                      // onEdit={checkEdit}
                    />
                  </Grid>
                  {/* <Grid item xs={6} display="flex" justifyContent={"flex-start"} alignItems={"center"} sx={{ display: 'none' }}>
                    <FormInputCheckbox
                      name="validYN"
                      control={control}
                      setValue={setValue}
                      onChangeCheckValue={handleChangeCheckButton}
                    />
                    <Typography>{"만료일 없음"}</Typography>
                  </Grid> */}
                </Grid>
              </Grid>
              {/* 파일명 출력 */}
              <Grid item xs={12}>
                <Typography sx={{ display: 'flex', alignItems: 'center', color: uploadedDocumentPath ? 'primary.main' : 'text.secondary' }}>
                  {displayFileName ? (
                    <>
                      <InsertDriveFile sx={{ mr: 1, fontSize: 20, color: uploadedDocumentPath ? 'primary.main' : 'text.secondary' }} />
                      {displayFileName}
                    </>
                  ) : (
                    ''
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12}>
              {uploadedDocumentPath && (
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  color: '#2e7d32',
                  fontSize: '14px'
                }}>
                  <Info sx={{ mr: 1 }} />
                  파일 업로드가 완료 되었습니다. <br />서류 만료일 선택 후 [서류저장] 버튼을 클릭하여 서류첨부를 완료해 주세요.
                </Box>
              )}
              </Grid>
              {/* {
                selectedDocuFileType === 'CERTIFICATION' && (
                  <Grid item xs={12}>
                    {JSON.stringify()}
                  </Grid>
                )
              } */}
              {/* 파일 업로드 */}
              {!gtestComparisonShow && (
                <Grid item xs={12}>
                  <FilePond
                    ref={ref => pond = ref}
                    files={files}
                    credits={false}
                    // allowDownloadByUrl={false} // by default downloading by URL disabled
                    allowMultiple={false}
                    allowReplace={false}
                    allowProcess={false}
                    allowRevert={false}
                    instantUpload={true}  // 즉시 업로드 활성화
                    acceptedFileTypes={['image/*', 'application/pdf']}
                    onupdatefiles={setFiles} // onupdatefiles(files)
                    labelIdle={uploadLabels.labelIdle} // 기본 업로드 메시지만 유지
                    // 다이얼로그 열기 : oninit
                    // 파일 첨부 : beforeAddFile -> oninitfile -> onaddfilestart -> onaddfile
                    // 서버로 업로드 : server:process:ondata -> onpreparefile -> server:process:onload -> onprocessfilestart -> onprocessfileprogress -> onprocessfile -> onprocessfiles
                    // 서버에서 삭제 : onprocessfilerevert -> server:revert:ondata
                    // 파일삭제나 다이얼로그 닫기 : beforeRemoveFile -> onremovefile
                    oninit={() => { //	FilePond instance has been created and is ready.
                      console.log("oninit");
                    }}
                    onwarning={(error, file, status) => { //	FilePond instance throws a warning. For instance when the maximum amount of files has been reached. Optionally receives file if error is related to a file object.
                      console.log("onwarning");
                      console.log(error, file, status);
                    }}
                    onerror={(error, file, status) => { //	FilePond instance throws an error. Optionally receives file if error is related to a file object.
                      console.log("onerror");
                      console.log(error, file, status);
                    }}
                    onprocessfileprogress={(file, progress) => { //	Made progress processing a file
                      console.log("onprocessfileprogress");
                      console.log(file, progress);
                    }}
                    onprocessfile={(error, file) => { //	Finished processing a file, if the detail object contains an error property, something went wrong
                      console.log("onprocessfile");
                      console.log(error, file);
                    }}
                    onremovefile={(error, file) => { //	File has been removed
                      console.log("onremovefile");
                      console.log(error, file);
                    }}
                    server={{
                      url: gcoreServerUrl,
                      timeout: 700000,
                      process: {
                          // url: '/api/g04docuFiles/uploadFile',
                          url: `/api/g04docuFiles/uploadFile`,
                          headers: {
                            Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
                          },
                          // 요청 전 데이터 가공
                          ondata: (formData) => {
                            console.log("server:process:ondata");
                            console.log('g04docuGCertificationId:', g04docuGCertificationId, ',g04docuGCertificationName:', g04docuGCertificationName, ',g04docuGTestId:', g04docuGTestId, ',g04docuGTestName:', g04docuGTestName, ',gcomponentItemId:', selectedGComponentItemId, ',gcomponentItemName:', selectedGComponentItemName);
                            // TODO : 이렇게 body로 데이터를 넘길지 header를 사용할지 추후 검토. 우선은 body 사용
                            formData.append('gclientId', selectedGClientId);
                            formData.append('gclientName', selectedGClient?.name);
                            formData.append('division', division);

                            formData.append('g04docuGCertificationId', currG04docuGCertificationId);
                            formData.append('g04docuGCertificationName', currG04docuGCertificationName);
                            if (selectedDocuFileType === 'TEST') {
                              formData.append('gcomponentItemId', currGComponentItemId)
                              formData.append('gcomponentItemName', currGComponentItemName)
                              formData.append('g04docuGTestId', currG04docuGTestId)
                              formData.append('g04docuGTestName', currG04docuGTestName)
                            }
                            formData.append('docuFileType', selectedDocuFileType);
                            // 주의 : build하면 files가 []임. 원인파악 안됨. 확인결과 pond.getFiles()는 사용가능하여 이 코드로 대체
                            // formData.append('fileName', files[0].filename); // TODO : 한글 파일명인 경우 filepond를 그대로 쓸 경우 서버에서 인코딩 문제가 발생. 현재 해결 못하여 fileName을 설정함 => filepond 문제가 아닌 거 같음
                            formData.append('fileName', (pond.getFiles())[0].filename); // TODO : 한글 파일명인 경우 filepond를 그대로 쓸 경우 서버에서 인코딩 문제가 발생. 현재 해결 못하여 fileName을 설정함
                            //formData.append('validYN', true);
                            // formData.append('endDate', getValues('endDate')); // 이렇게 보내면 null이 string으로 전달됨
                            let newEndDate = getValues('endDate');
                            newEndDate = newEndDate ? dateFormat(newEndDate.getDateWithEndHours()) : null;
                            if (newEndDate) {
                              formData.append('endDate', newEndDate);
                            }

                            
                            // 시험성과대비표 자동작성을 위한 데이터 준비. 두께와 등급 등 필요정보를 만들어서 서버로 전달 (서버에서 leadField와 전달된 정보를 사용하여 시험성과대비표 데이터 구성)
                            const jsonData = prepareTestComparisonData(selectedRow, division);
                            formData.append('jsonData', JSON.stringify(jsonData));
                            
                            return formData;
                          },
                          // 업로드 완료
                          onload: async (res) => { // 서버에서 api 동작 후 리턴되는 callback
                            const startDate = getValues("startDate");
                            const endDate = getValues("endDate");

                            const response = JSON.parse(res);
                            console.log("response => ", res)
                            console.log("response.json => ", response)
                            console.log("response.file : ", response.file, uploadedDocumentPath);

                            // 성적서 QR스캔을 통해 만들어진 시험성과대비표 데이터. QR 스캔 실패(QR이 없는 성적서-현재 KCL, KTR 성적서가 아닌 경우)시 기존 DB정보가 넘어온다.
                            // 현재는 QR이 아닌 경우는 여기 리턴값이 아닌 다이얼로그 띄울 때 가져온 데이터를 사용하고 있음 => 서버팀과 논의 후 수정할지 검토
                            const { testResult } = response;
                            if (testResult) {
                              const { extractType,  g04docuGTestComparisons } = testResult;
                              if (extractType === 'QR' && g04docuGTestComparisons && Array.isArray(g04docuGTestComparisons) && g04docuGTestComparisons.length > 0) {
                                setRowsG04docuGTestComparison(g04docuGTestComparisons.map(test => ({ ...test, id: uuidv4()})));
                              }
                            }

                            // 파일을 계속 업로드 할 경우 이전에 업로드한 파일 삭제
                            if (uploadedDocumentPath) {
                              // 원본 파일명과 업로드 파일 비교, 이전 업로드 파일과 현재 업로드 파일 비교
                              if (originalDocumentPath !== uploadedDocumentPath && uploadedDocumentPath !== response.file) {
                                await removeG04docuFile(uploadedDocumentPath)
                                    .then(() => {
                                        console.log("이전 업로드 파일 삭제 완료 ......");
                                        return true; // 계속 진행
                                    })
                                    .catch(err => {
                                        console.error("이전 파일 삭제 실패:", err);
                                        return true; // 오류가 있어도 계속 진행
                                    });
                              }
                            }

                            //console.log("업로드 완료 후 임시 파일 설정 완료 ......");
                            // setDisplayFileName((pond.getFiles())[0].filename || (pond.getFiles())[0].file?.name);  // 파일명 표시
                            setDisplayFileName(response.file.split('/').pop());
                            setUploadedDocumentPath(response.file);
                            
                            if (response?.testResult?.g04docuGTestComparisons) {
                              // id 추가
                              const tempComparisonsWithId = response.testResult.g04docuGTestComparisons.map((comparison, index) => ({
                                ...comparison,
                                id: index + 1  // 또는 다른 고유한 값 사용
                              }));
                              
                              // 원본 데이터 업데이트 (QR 스캔으로 새로 생성된 데이터가 있다면)
                              if (tempComparisonsWithId.length > 0) {
                                setOriginalRowsG04docuGTestComparison(JSON.parse(JSON.stringify(tempComparisonsWithId)));
                              }
                            }

                            // FilePond 초기화 및 files 상태 초기화
                            if (pond) {
                              pond.removeFiles();
                              setFiles([]);
                            }

                            return res;
                          },
                          onerror: (res) => {
                            console.log({ res, type: typeof res });
                            // node 서버 : {"msg":"invalid endDate"}
                            // java api 서버 : {"code":43001,"title":"Upload File Error.","message":"invalid endDate"}
                            if (typeof res === 'string') {
                              let needAlert = false;
                              const jsonRes = JSON.parse(res);
                              if (mode.indexOf('java') > 0) {
                                console.log(jsonRes)
                                if (jsonRes.code === 43001 || jsonRes.code === '43001') {
                                  needAlert = true;
                                }
                              } else {
                                if (jsonRes.msg === 'invalid endDate') {
                                  needAlert = true;
                                }
                              }

                              if (needAlert) {
                                setAlertInfo({
                                  titleAlert: "안내",
                                  messageAlert: (
                                    <div>
                                      <span style={{ color: "#d32f2f" }}><i><u>{"만료일"}</u></i></span>
                                      <span>{"이 유효하지 않습니다."}</span>
                                    </div>
                                  ),
                                  open: true,
                                });
                              }
                            }
                          },
                      },
                      fetch: {
                        url: `/api/g04docuFiles/fetchFile/`,
                        method: 'GET',
                        // 중요: 아래 헤더가 없으면 backend에서 req.body를 얻지 못함
                        headers: {
                          "Content-Type": "application/json"
                        },
                      },
                      revert: {
                        url: `/api/g04docuFiles/deleteFile`,
                        method: 'DELETE',
                        // 중요: 아래 헤더가 없으면 backend에서 req.body를 얻지 못함
                        headers: {
                          "Content-Type": "application/json"
                        },
                        onload: /*async*/ (res) => { // 서버에서 api 동작 후 리턴되는 callback
                          // console.log("server:revert:ondata1");
                          // console.log(res);
                          // console.log(JSON.parse(res).file);
                          if (selectedDocuFileType === 'CERTIFICATION') {
                            removeGClientG04docuGCertificationMap({ gclientId: selectedGClientId, g04docuGCertificationId, documentPath: JSON.parse(res).file })
                            .then(response => {
                              setValue("endDate", null);
                              setUploadedDocumentPath("");
                              // setDisabled(true);
                              // setDisabledRemoveButton(true);
                              
                              refresh(selectedGClientId);
                            });
                          } else if (selectedDocuFileType === 'TEST') {
                            removeGClientG04docuGTestMap({ gclientId: selectedGClientId, g04docuGTestId, documentPath: JSON.parse(res).file })
                            // .then(res => refresh(selectedGComponentItemType === 'PROCESS' ? g04docuGCertificationId : selectedGComponentItemId, selectedGComponentItemType, selectedGClientId));
                            .then(response => {
                              setValue("endDate", null);
                              setUploadedDocumentPath("");
                              // setDisabled(true);
                              // setDisabledRemoveButton(true);
                              
                              if (from === 'PROFILE') {
                                division === 'PROCESS' ? refresh(selectedGClientId) : refresh(selectedGClientId, division);
                              } else {
                                refresh(selectedGComponentItemType === 'PROCESS' ? g04docuGCertificationId : selectedGComponentItemId, selectedGComponentItemType, selectedGClientId);
                              }
                            });
                          }
                          
                          return res;
                        },
                      },        
                    }}
                  >
                  </FilePond>
                </Grid>
              )}
              { 
                !gtestComparisonShow && selectedDocuFileType === 'TEST' && (
                  <Grid item xs={12} sx={{ color: '#1976d2', fontSize: '0.8rem' }}>
                    &#8251;&nbsp;{"시험성과대비표를 만드시려면 성적서를 먼저 첨부해주세요."}
                  </Grid>
                )
              }
            </Grid>
          )}
          {/* 스플릿바 적용: 시험성과대비표 보기 모드일 때만 */}
          {gtestComparisonShow && (
            <Card sx={{ m: 3, p: 2 }}>
              <PanelGroup direction="horizontal" style={{ height: '750px' }}>
                {/* 성적서 패널 */}
                <Panel defaultSize={40} minSize={20} maxSize={80}>
                  <Box sx={{ pr: 2, height: '100%' }}>
                    <Grid container>
                      <Grid item xs={12} display="flex" alignItems="center">
                        <Typography variant="subtitle1" sx={{ ml: 1, fontWeight: 'bold' }}>∙ 성적서</Typography>
                      </Grid>
                    </Grid>
                    <div style={{ height: 700, width: '100%', marginTop: '8px' }}>
                      <iframe src={toFileServerUrl(originalDocumentPath) || toFileServerUrl(uploadedDocumentPath)} width="100%" height="100%"></iframe>
                    </div>
                  </Box>
                </Panel>
                {/* 스플릿바 */}
                <PanelResizeHandle
                  style={{
                    width: '8px',
                    backgroundColor: '#e0e0e0',
                    cursor: 'col-resize',
                    position: 'relative',
                  }}
                  onMouseEnter={e => { e.target.style.backgroundColor = '#9e9e9e'; }}
                  onMouseLeave={e => { e.target.style.backgroundColor = '#e0e0e0'; }}
                />
                {/* 시험성과대비표 패널 */}
                <Panel defaultSize={60} minSize={20} maxSize={80}>
                  <Box sx={{ pl: 2, height: '100%' }}>
                    <Grid container spacing={1} sx={{ mb: 1 }}>
                      <Grid item xs={12} sm={12} md={3} lg={2} display="flex" justifyContent="flex-start" alignItems="center">
                        <Typography 
                          variant="subtitle1" 
                          sx={{ 
                            ml: 1, 
                            fontWeight: 'bold',
                            fontSize: { xs: '0.875rem', sm: '1rem' },
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {"∙ 시험성과대비표"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12} md={9} lg={10} display="flex" justifyContent="flex-end" alignItems="center" flexWrap="wrap" gap={1}>
                        <Tooltip title="목록의 마지막에 시험항목 한 행을 추가합니다.">
                          <Button 
                            color="primary" 
                            startIcon={<Add />} 
                            onClick={handleClickAdd}
                            size="small"
                            sx={{ 
                              fontSize: { xs: '0.75rem', sm: '0.875rem' },
                              minWidth: { xs: 'auto', sm: 'auto' },
                              px: { xs: 1, sm: 2 }
                            }}
                          >
                            {"추가"}
                          </Button>
                        </Tooltip>
                        <Tooltip title="시험결과를 저장하고 시험성과대비표(PDF)를 작성합니다.">
                          <Button 
                            color="primary" 
                            startIcon={<Save />} 
                            onClick={handleClickG04docuGTestComparison}
                            size="small"
                            sx={{ 
                              fontSize: { xs: '0.75rem', sm: '0.875rem' },
                              minWidth: { xs: 'auto', sm: 'auto' },
                              px: { xs: 1, sm: 2 }
                            }}
                          >
                            {"저장"}
                          </Button>
                        </Tooltip>
                        <Tooltip title="수정하신 내용을 취소하고 원래의 상태로 되돌립니다.">
                          <Button 
                            color="primary" 
                            startIcon={<Undo />} 
                            onClick={handleClickSearchG04docuGTestComparison} 
                            disabled={!hasChanges}
                            size="small"
                            sx={{ 
                              fontSize: { xs: '0.75rem', sm: '0.875rem' },
                              minWidth: { xs: 'auto', sm: 'auto' },
                              px: { xs: 1, sm: 2 }
                            }}
                          >
                            {"작업취소"}
                          </Button>
                        </Tooltip>
                        {sessionUserType === 'ADMIN' && (
                          <Tooltip title="성적서를 다시 분석하여 시험성과대비표를 목록을 새로 구성합니다.">
                            <Button 
                              color="primary" 
                              startIcon={<DocumentScanner />} 
                              onClick={handleClickAnalyzeG04docuGTestComparison} 
                              size="small"
                              sx={{ 
                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                minWidth: { xs: 'auto', sm: 'auto' },
                                px: { xs: 1, sm: 2 }
                              }}
                            >
                              {"다시분석"}
                            </Button>
                          </Tooltip>
                        )}
                        {!rowsG04docuGTestComparison.some(row => row.office) && (
                          <Tooltip title="표준 시험항목을 불러와 시험항목 목록을 초기화합니다.">
                            <Button 
                              color="primary" 
                              startIcon={<Refresh />} 
                              onClick={handleClickInitG04docuGTestComparison}
                              size="small"
                              sx={{ 
                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                minWidth: { xs: 'auto', sm: 'auto' },
                                px: { xs: 1, sm: 2 }
                              }}
                            >
                              {"새로고침"}
                            </Button>
                          </Tooltip>
                        )}
                        {selectedRow.guideLink && (
                          <Tooltip title={`${selectedRow.gstandardName?.replace(/\s+/g, '')} (${selectedRow.gstandardNo})`}>
                            <Button 
                              startIcon={<MenuBook />} 
                              size="small"
                              sx={{ 
                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                minWidth: { xs: 'auto', sm: 'auto' },
                                px: { xs: 1, sm: 2 }
                              }}
                            >
                              <Link href={selectedRow.guideLink} underline="none" target="_blank" rel="noopener">규격문서 보기</Link>
                            </Button>
                          </Tooltip>
                        )}
                      </Grid>
                    </Grid>
                    <div style={{ height: 700, width: '100%' }}>
                      <DataGridPro
                        localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
                        getCellClassName={(params) => {
                          if (params.row.office && !['criterion', 'result', 'method'].includes(params.field)) {
                            return 'disabled-row';
                          }
                          return '';
                        }}
                        sx={{
                          cursor: 'pointer',
                          fontSize: '0.85em',
                          '& .disabled-row': {
                            '&:hover': { backgroundColor: '#eeeeee' },
                            opacity: 0.85,
                            cursor: 'not-allowed',
                          }
                        }}
                        slots={{
                          noRowsOverlay: CustomNoRowsOverlay,
                          loadingOverlay: LinearProgress,
                        }}
                        headerHeight={38}
                        rowHeight={34}
                        rows={rowsG04docuGTestComparison}
                        columns={columnsGTestComparison}
                        loading={!loaded}
                        disableColumnMenu
                        rowReordering
                        editMode="cell"
                        isCellEditable={(params) => {
                          if (params.field === 'criterion' || params.field === 'result' || params.field === 'method') {
                            return true;
                          }
                          return !params.row.office;
                        }}
                        onCellModesModelChange={handleCellModesModelChange}
                        onCellClick={handleCellClick}
                        onCellEditCommit={handleCellEditCommit}
                        processRowUpdate={processRowUpdate}
                        rowModesModel={rowModesModel}
                        cellModesModel={cellModesModel}
                        onRowOrderChange={handleRowOrderChange}
                      />
                    </div>
                  </Box>
                </Panel>
              </PanelGroup>
            </Card>
          )}
        </DialogContent>
        <DialogActions>
          {!gtestComparisonShow && originalDocumentPath && (
            <>
              {deleteButton && !uploadedDocumentPath && (
                <Button onClick={handleClickDelete} sx={{ ml: '20px' }}>서류삭제</Button>
              )}
              <Box sx={{ flex: 1 }} /> {/* 스페이서 */}
            </>
          )}
          {
            (selectedDocuFileType === 'TEST' && (originalDocumentPath || uploadedDocumentPath)) && (
              <Button 
                onClick={handleClickG04docuTestComparison}
                disabled={uploadedDocumentPath} // uploadedDocumentPath가 true이면 버튼 비활성화
              >
                {gtestComparisonShow ? "시험성과대비표 접기" : (fromGTestComparison ? "시험성과대비표 만들기" : "시험성과대비표 보기" )}
              </Button>
            )
          }
          {
            !gtestComparisonShow && (
              <>
                <Button onClick={handleClickSave}>{"서류저장"}</Button>
                {/* <Button onClick={comfirmRemove} disabled={disabledRemoveButton}>{"삭제"}</Button> */}
              </>
            )
          }
          <Button onClick={handleDialogClose}>{"닫기"}</Button>
        </DialogActions>
      </Dialog>
      <AlertDialog
        alertInfo={alertInfo}
        setAlertInfo={setAlertInfo}
      />
      {/* <ConfirmDialog
        removeId={""}
        title={"삭제"}
        open={confirmOpen}
        setOpen={setConfirmOpen}
        onConfirm={removeFile}
        onCancel={() => {}}
      >
        {"첨부된 서류를 삭제하시겠습니까?"}
      </ConfirmDialog> */}
    </>
  );
};

export default G04docuFileDialogEx;
